import { ListItemIcon, ListItemText, Menu, MenuItem, PopoverProps } from '@mui/material';
import { v2MenuItemSizeClass } from '@onevision-resources/design-theme';
import { Clock, Monitor } from 'lucide-react';
import { useMemo } from 'react';
import { TimeFormats } from 'src/graphql';

const timeFormatOptions: {
  label: string;
  value: TimeFormats;
  selectedLabel: string;
  icon: React.ReactElement;
}[] = [
  {
    value: TimeFormats.TwelveHour,
    label: '12-hour',
    get selectedLabel() {
      return `${this.label} clock`;
    },
    icon: <Clock />,
  },
  {
    value: TimeFormats.TwentyFourHour,
    label: '24-hour',
    get selectedLabel() {
      return `${this.label} clock`;
    },
    icon: <Clock />,
  },
  {
    value: TimeFormats.Auto,
    selectedLabel: 'System default',
    label: 'Auto',
    icon: <Monitor />,
  },
];

export const useTimeFormatSwitch = ({
  isOpen,
  selectedFormat,
  onClose,
  onChange,
  anchorEl,
}: {
  isOpen: boolean;
  selectedFormat: TimeFormats;
  onClose?: () => void;
  onChange: (value: TimeFormats) => void;
  anchorEl: PopoverProps['anchorEl'];
}) => {
  const { selectedTimeFormatLabel, timeFormatsMenu } = useMemo(() => {
    return {
      selectedTimeFormatLabel: timeFormatOptions.find(
        (option) => option.value === selectedFormat,
      )?.selectedLabel,
      timeFormatsMenu: (
        <Menu
          anchorEl={anchorEl}
          open={isOpen}
          onClose={onClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {Object.entries(timeFormatOptions).map(([, option]) => (
            <MenuItem
              className={v2MenuItemSizeClass.large}
              selected={option.value === selectedFormat}
              key={option.label}
              onClick={() => {
                onChange(option.value);
                onClose?.();
              }}
            >
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText>{option.label}</ListItemText>
            </MenuItem>
          ))}
        </Menu>
      ),
    };
  }, [anchorEl, isOpen, onChange, onClose, selectedFormat]);

  return useMemo(
    () => ({
      timeFormatsMenu,
      selectedTimeFormatLabel,
    }),
    [timeFormatsMenu, selectedTimeFormatLabel],
  );
};
